/**
 * The default icons for the BS5 dialog.
 * @type {Object.<string, string>}
 */
export const BS5_DIALOG_DEFAULT_ICONS = {
  "bs5-check": `<svg xmlns="http://www.w3.org/2000/svg" class="" width="24" height="24" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
  <path d="M5 12l5 5l10 -10"></path>
</svg>`,
  "bs5-circle-check": `<svg xmlns="http://www.w3.org/2000/svg" class="" width="24" height="24" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
<path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
<path d="M9 12l2 2l4 -4"></path>
</svg>`,
  "bs5-circle-check-filled": `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-circle-check-filled" width="24" height="24" viewBox="0 0 24 24" stroke-width="0.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
<path d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z" stroke-width="0" fill="currentColor"></path>
</svg>`,
  "bs5-square": `<svg xmlns="http://www.w3.org/2000/svg" class="" width="48" height="48" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
<path d="M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"></path>
</svg>`,
  "bs5-minimize": `<svg xmlns="http://www.w3.org/2000/svg" onMouseOver="this.style.color='#000'" onMouseOut="this.style.color='#7f7f7f'"  width="24" height="24" viewBox="0 0 24 24" stroke-width="1.8"  stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
  <path d="M15 19v-2a2 2 0 0 1 2 -2h2"></path>
  <path d="M15 5v2a2 2 0 0 0 2 2h2"></path>
  <path d="M5 15h2a2 2 0 0 1 2 2v2"></path>
  <path d="M5 9h2a2 2 0 0 0 2 -2v-2"></path>
</svg>`,
  "bs5-maximize": `<svg xmlns="http://www.w3.org/2000/svg" onMouseOver="this.style.color='#000'" onMouseOut="this.style.color='#7f7f7f'"  width="24" height="24" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
  <path d="M4 8v-2a2 2 0 0 1 2 -2h2"></path>
  <path d="M4 16v2a2 2 0 0 0 2 2h2"></path>
  <path d="M16 4h2a2 2 0 0 1 2 2v2"></path>
  <path d="M16 20h2a2 2 0 0 0 2 -2v-2"></path>
</svg>`,
  "bs5-alert": `<svg xmlns="http://www.w3.org/2000/svg" class="" width="48" height="48" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
<path d="M12 8v4"></path>
<path d="M12 16h.01"></path>
</svg>`,
  "bs5-alert-circle": `<svg xmlns="http://www.w3.org/2000/svg" class="" width="48" height="48" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
<path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
<path d="M12 8v4"></path>
<path d="M12 16h.01"></path>
</svg>`,
  "bs5-help": `<svg xmlns="http://www.w3.org/2000/svg" class="" width="48" height="48" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
<path d="M12 16v.01"></path>
<path d="M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"></path>
</svg>`,
  "bs5-help-circle": `<svg xmlns="http://www.w3.org/2000/svg" class="" width="48" height="48" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
<path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
<path d="M12 17l0 .01"></path>
<path d="M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4"></path>
</svg>`,
  "bs5-info": `<svg xmlns="http://www.w3.org/2000/svg" class="" width="48" height="48" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
<path d="M12 9h.01"></path>
<path d="M11 12h1v4h1"></path>
</svg>`,
  "bs5-info-circle": `<svg xmlns="http://www.w3.org/2000/svg" class="" width="48" height="48" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
<path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
<path d="M12 9h.01"></path>
<path d="M11 12h1v4h1"></path>
</svg>`,
  "bs5-reload": `<svg xmlns="http://www.w3.org/2000/svg" class="" width="48" height="48" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
<path d="M19.933 13.041a8 8 0 1 1 -9.925 -8.788c3.899 -1 7.935 1.007 9.425 4.747"></path>
<path d="M20 4v5h-5"></path>
</svg>`,
  "bs5-code": `<svg xmlns="http://www.w3.org/2000/svg" class="" width="3.5rem" height="3.5rem" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
  <path d="M7 8l-4 4l4 4"></path>
  <path d="M17 8l4 4l-4 4"></path>
  <path d="M14 4l-4 16"></path>
</svg>`,

  "bs5-alert-danger": `<svg xmlns="http://www.w3.org/2000/svg" class="text-danger" width="3.5rem" height="3.5rem" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
<path d="M10.24 3.957l-8.422 14.06a1.989 1.989 0 0 0 1.7 2.983h16.845a1.989 1.989 0 0 0 1.7 -2.983l-8.423 -14.06a1.989 1.989 0 0 0 -3.4 0z"></path>
<path d="M12 9v4"></path>
<path d="M12 17h.01"></path>
</svg>`,

  "bs5-alert-warning": `<svg xmlns="http://www.w3.org/2000/svg" class="text-warning" width="3.5rem" height="3.5rem" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
<path d="M10.24 3.957l-8.422 14.06a1.989 1.989 0 0 0 1.7 2.983h16.845a1.989 1.989 0 0 0 1.7 -2.983l-8.423 -14.06a1.989 1.989 0 0 0 -3.4 0z"></path>
<path d="M12 9v4"></path>
<path d="M12 17h.01"></path>
</svg>`,

  "bs5-alert-success": `<svg xmlns="http://www.w3.org/2000/svg" class="text-success" width="3.5rem" height="3.5rem" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
<path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
<path d="M9 12l2 2l4 -4"></path>
</svg>`,
  "bs5-point": `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-point" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
<path d="M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"></path>
</svg>`
};

/**
 * Creates an icon element with the given name, class, and style.
 * @param {string} iconName - The name of the icon.
 * @param {string} iconClass - The class of the icon.
 * @param {string} iconStyle - The style of the icon.
 * @returns {HTMLElement} - The icon element.
 */
export function makeIcon(iconName = "", iconClass = "", iconStyle = "") {
  iconName = iconName.replace(/\s+/g, " ");
  iconClass = iconClass.replace(/\s+/g, " ");
  iconStyle = iconStyle.replace(/\s+/g, " ");
  // create a new icon element
  let iconElement = document.createElement("i");
  if (!iconName) {
    return iconElement;
  }

  // check if the icon is in the default icon map
  const defaultIcon = BS5_DIALOG_DEFAULT_ICONS[iconName];
  if (defaultIcon) {
    // check if the default icon is an SVG string
    if (defaultIcon.startsWith("<svg")) {
      iconElement.innerHTML = defaultIcon;
      iconElement = iconElement.firstChild;
    } else {
      iconElement.classList.add(...defaultIcon.trim().split(" "));
    }
  } else {
    // assume the icon is a class name or SVG string
    if (iconName.startsWith("<svg")) {
      iconElement.innerHTML = iconName;
      iconElement = iconElement.firstChild;
    } else {
      if (iconName.trim()) {
        iconElement.classList.add(...iconName.trim().split(" "));
      }
    }
  }

  // add iconClass to the icon element
  if (iconClass.trim()) {
    iconElement.classList.add(...iconClass.trim().split(" "));
  }

  // add custom styles to the icon element
  if (iconStyle.trim()) {
    const styles = iconStyle.split(";");
    styles.forEach(style => {
      const [property, value] = style.split(":");
      if (property && value) {
        iconElement.style.setProperty(property.trim(), value.trim());
      }
    });
  }

  return iconElement;
}
